<div class="three-pane-layout">
    @if ((showLeftSidebar() && isLeftOpen()) || (showRightSidebar() && isRightOpen())) {
    <button class="sidebar-backdrop" type="button" (click)="closeSidebars()"
        [attr.aria-label]="'Close sidebars'"></button>
    }
    @if (showLeftSidebar() && isLeftOpen()) {
    <aside class="sidebar sidebar--left" [style.width.px]="leftSidebarSize()" [style.flex-basis.px]="leftSidebarSize()"
        [attr.aria-label]="leftSidebarLabel()">
        <button class="sidebar__toggle" type="button" (click)="toggleLeft()" [attr.aria-label]="leftToggleLabel()">
            <app-icon class="sidebar-toggle__icon" [icon]="leftSidebarIcon" [width]="20" [height]="20"
                aria-hidden="true" [color]="'currentColor'" />
            <app-icon class="sidebar-toggle__icon sidebar-toggle__icon--solid" [icon]="leftSidebarSolidIcon"
                [width]="20" [color]="'currentColor'" [height]="20" aria-hidden="true" />
        </button>
        <ng-content select="[left-sidebar]"></ng-content>
    </aside>
    <hr class="sidebar-resize" aria-hidden="true" (pointerdown)="startResize($event, 'left')" />
    } @else if (showLeftSidebar()) {
    <button class="sidebar-toggle sidebar-toggle--left" type="button" (click)="toggleLeft()"
        [attr.aria-label]="leftToggleLabel()">
        <app-icon class="sidebar-toggle__icon" [icon]="leftSidebarIcon" [width]="20" [height]="20" aria-hidden="true"
            [color]="'currentColor'" />
        <app-icon class="sidebar-toggle__icon sidebar-toggle__icon--solid" [icon]="leftSidebarSolidIcon" [width]="20"
            [height]="20" aria-hidden="true" [color]="'currentColor'" />
    </button>
    }

    <main class="three-pane-layout__content">
        <ng-content></ng-content>
    </main>

    @if (showRightSidebar() && isRightOpen()) {
    @if (showRightSidebarResize()) {
    <hr class="sidebar-resize" aria-hidden="true" (pointerdown)="startResize($event, 'right')" />
    }
    <aside class="sidebar sidebar--right" [style.width.px]="rightSidebarSize()"
        [style.flex-basis.px]="rightSidebarSize()" [attr.aria-label]="rightSidebarLabel()">
        @if (showRightSidebarToggle()) {
        <button class="sidebar__toggle" type="button" (click)="toggleRight()" [attr.aria-label]="rightToggleLabel()">
            <app-icon class="sidebar-toggle__icon" [icon]="rightSidebarIcon" [width]="20" [height]="20"
                aria-hidden="true" [color]="'currentColor'" />
            <app-icon class="sidebar-toggle__icon sidebar-toggle__icon--solid" [icon]="rightSidebarSolidIcon"
                [width]="20" [height]="20" aria-hidden="true" [color]="'currentColor'" />
        </button>
        }
        <ng-content select="[right-sidebar]"></ng-content>
    </aside>
    } @else if (showRightSidebar() && showRightSidebarToggle()) {
    <button class="sidebar-toggle sidebar-toggle--right" type="button" (click)="toggleRight()"
        [attr.aria-label]="rightToggleLabel()">
        <app-icon class="sidebar-toggle__icon" [icon]="rightSidebarIcon" [width]="20" [height]="20" aria-hidden="true"
            [color]="'currentColor'" />
        <app-icon class="sidebar-toggle__icon sidebar-toggle__icon--solid" [icon]="rightSidebarSolidIcon" [width]="20"
            [height]="20" aria-hidden="true" [color]="'currentColor'" />
    </button>
    }
</div>
